import {h, Component, Fragment, createRef} from 'preact';
import PropTypes from 'prop-types';
import {prettyPhase, sendRequest, validateEmail, validateByPattern} from "../../tools";
import SelectInput from "./SelectInput";
import TextInput from "./TextInput";

export default class ServiceForm extends Component {
	static propTypes = {
		urlCreate: PropTypes.string.isRequired,
		urlGetDeliveryZone: PropTypes.string.isRequired,
		urlGetPlaneDate: PropTypes.string.isRequired,
		urlGetTimeSlot: PropTypes.string.isRequired,
		contracts: PropTypes.array.isRequired,
		cost: PropTypes.number.isRequired,
		products: PropTypes.string.isRequired,
		productName: PropTypes.string.isRequired,
		onSubmited: PropTypes.func,
		typeForm: PropTypes.string,
		firstName: PropTypes.string,
		secondName: PropTypes.string,
		email: PropTypes.string,
		phone: PropTypes.string,
	};

	constructor(props){
		super(props);

		this.phoneInputRef = createRef();
		this.state = {
			values: {},
			date: [],
			timeSlot: [],
			loading: false
		};
		this.submitted = false;
		this.deliveryZoneId = '';
		this.requiredFields = [
			'city',
			'contractGlobalId',
			'street',
			'house',
			'lastName',
			'firstName',
			'phoneNumber',
			'email',
			'products',
			'planeDate',
			'timeSlot',
		];
		this.fieldsName = {
			regPointId: 'Номер прибора учета',
			lastName: 'Фамилия',
			firstName: 'Имя',
			phoneNumber: 'Номер телефона',
			email: 'E-mail',
			planeDate: 'Дата',
			timeSlot: 'Время',
			city: 'Город',
			contractGlobalId: 'Номер договора',
			street: 'Улица',
			house: 'Дом',
			products: 'Услуга',
		};
		this.errorsApi = {};
	}

	clearForm = () => {
		this.submitted = false;
		this.errorsApi = {}
		const contract = this.props.contracts[0];
		this.getDeliveryZone(contract.city, contract.street, contract.house);

		this.setState({
			date: [],
			timeSlot: [],
			values: {
				lastName: '',
				firstName: this.props.firstName,
				surname: this.props.secondName,
				phoneNumber: this.props.phone,
				email: this.props.email,
				planeDate: '',
				timeSlot: '',
				paymentType: '',
				products: this.props.products,
				contractGlobalId: typeof contract !== "undefined" ? contract.contractGlobalId: '',
				regPointId: typeof contract !== "undefined" ? (contract['meterDevice'].length ? contract['meterDevice'][0].serialNumber:''):'',
				city: contract.city,
				street: contract.street,
				house: contract.house,
				flat: contract.flat,
			}
		});
		$(this.phoneInputRef.current).inputmask('setvalue', this.props.phone);
	};

	componentDidMount(){
		const self = this;
		self.clearForm();
		$(this.phoneInputRef.current).inputmask({
			mask: '+7 (999) 999 9999',
			clearIncomplete: true,
			oncomplete: function (e) {
				self.setValues({phoneNumber: e.target.value});
			},
			onincomplete: function() {
				self.setValues({phoneNumber: ''});
			}
		});
	}

	render(props, state, context){
		const errors = {...this.errorsApi, ...this.validate()};
		const contract = this.props.contracts.find(item => item.contractGlobalId === state.values.contractGlobalId) || [],
			meterDevices = 'meterDevice' in contract ? contract.meterDevice:[];
		const meterDevice = meterDevices.find(item => item.serialNumber === state.values.regPointId)
		let phase = '';

		if(props.typeForm === 'formMeterReplacement' && meterDevice && meterDevice.phase)
		{
			phase = (
				<Fragment>
					<div className="counter-info form__item">
						<div className="counter-info__title">{prettyPhase(meterDevice.phase)}</div>
						<div className="counter-info__subtitle">тип вашего счетчика</div>
					</div>
				</Fragment>
			);
		}

		return (
			<form className="form">
				<div className="form__body">
					<div className="form__title-2">{props.productName}</div>
					<div className="form__fieldset">
						<div className="form__fieldset-title">Данные абонента</div>
						<div className="form__item form__item_horizontal">
							<TextInput errors={errors.lastName}
									   isRequired={this.isRequired('lastName')}
									   name="Фамилия"
									   inputProps={{
										   onChange: this.onChangeInput('lastName'),
										   value: state.values.lastName,
										   placeholder: "Введите фамилию",
										   id: "lastName",
									   }}
							/>
							<TextInput errors={errors.firstName}
									   isRequired={this.isRequired('firstName')}
									   name="Имя"
									   inputProps={{
										   onChange: this.onChangeInput('firstName'),
										   value: state.values.firstName,
										   placeholder: "Введите имя",
										   id: "firstName",
									   }}
							/>
							<TextInput errors={errors.surname}
									   isRequired={this.isRequired('surname')}
									   name="Отчество (при наличии)"
									   inputProps={{
										   onChange: this.onChangeInput('surname'),
										   value: state.values.surname,
										   placeholder: "Введите отчество",
										   id: "surname",
									   }}
							/>
						</div>
						<div className="form__item">
							<div className="form-field form-field_gray">
								<div className="form-field__inner">
									<div className="form-field__title-row">
										<legend className="form-field__title">{this.isRequired('contractGlobalId')}Адрес</legend>
									</div>
									<div className={`form-field__input-row ${'city' in errors || 'street' in errors || 'house' in errors ? 'form-field_state_error':''}`}>
										<SelectInput
											onChange={this.onChangeAddress}
											defaultValue=''
											name='address'
											checkedItem={state.values.contractGlobalId}
											getItemName={(item) => item.address}
											getItemValue={(item) => item.contractGlobalId}
											items={this.props.contracts}
											isCheckedValue={(item) => item.contractGlobalId === state.values.contractGlobalId}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
					{
						meterDevices.length > 1 && (
							<div className="form__item">
								<div className="form-field form-field_gray">
									<div className="form-field__inner">
										<div className="form-field__title-row">
											<label className="form-field__title">{this.isRequired('regPointId')}Серийный номер прибора учета, по которому нужно оказать услугу</label>
										</div>
										<div className={`form-field__input-row ${errors.regPointId ? 'form-field_state_error':''}`}>
											{
												<SelectInput
													onChange={this.onChangeInput('regPointId')}
													name='regPointId'
													items={meterDevices}
													checkedItem={state.values.regPointId}
													placeholder={state.values.regPointId}
													getItemName={(item) => item.serialNumber}
													getItemValue={(item) => item.serialNumber}
													isCheckedValue={(item) => item.serialNumber === state.values.regPointId}
												/>
											}
										</div>
									</div>
								</div>
							</div>
						)
					}
					{phase}

					<div className="form__fieldset">
						<div className="form__fieldset-title">Стоимость</div>
						<div className="form__item">
							<div className="form-info-block">
								<div className="form-info-block__item">
									<div className="form-info-block__name">Общая стоимость</div>
									<div className="form-info-block__value">{props.cost.toLocaleString('ru-RU', {maximumFractionDigits: 2, minimumFractionDigits: 0 })} р</div>
								</div>
							</div>
						</div>
					</div>
					<div className="form__fieldset">
						<div className="form__fieldset-title">Дата и время приема</div>
						<div className="form__item form__item_horizontal">
							<fieldset className="form-field form-field_gray">
								<div className="form-field__inner">
									<div className="form-field__title-row">
										<legend className="form-field__title">{this.isRequired('planeDate')}Дата</legend>
									</div>
									<div className={`form-field__input-row ${errors.planeDate ? 'form-field_state_error':''}`}>
										<SelectInput
											onChange={this.onChangeDatePlane}
											name='planeDate'
											items={this.state.date}
											checkedItem={state.values.planeDate}
											placeholder='Выберите день'
											getItemName={(item) => {
												const date = new Date(item.year, item.month - 1, item.day);
												return date.toLocaleDateString("ru", {
													year: "numeric",
													month: "long",
													day: "numeric"
												})
											}}
											getItemValue={(item) => `${item.day}.${item.month}.${item.year}`}
											isCheckedValue={(item) => `${item.day}.${item.month}.${item.year}` === state.values.planeDate}
										/>
									</div>
								</div>
							</fieldset>
							<div className="group-time">
								<div className="group-time__title">{this.isRequired('timeSlot')}Время</div>
								<div className="group-time__body">
									<fieldset className="form-field form-field_gray">
										<div className="form-field__inner">
											<div className={`form-field__input-row ${errors.timeSlot ? 'form-field_state_error':''}`}>
												<SelectInput
													onChange={this.onChangeInput('timeSlot')}
													name='timeSlot'
													items={this.state.timeSlot}
													checkedItem={state.values.timeSlot}
													placeholder='Выберите время'
													getItemName={(item) => item.name}
													getItemValue={(item) => item.id}
													isCheckedValue={(item) => item.id === state.values.timeSlot}
												/>
											</div>
										</div>
									</fieldset>
								</div>
							</div>
						</div>
					</div>
					<div className="form__fieldset">
						<div className="form__fieldset-title">Контактные данные</div>
						<div className="form__item form__item_horizontal">

							<div className={`form-field form-field_gray ${errors.phoneNumber ? 'form-field_state_error':''}`}>
								<div className="form-field__inner">
									<div className="form-field__title-row">
										<label className="form-field__title" htmlFor='phoneNumber'>{this.isRequired('phoneNumber')}Номер телефона</label>
									</div>
									<div className="form-field__input-row">
										<input className="input form-field__input" type="text" id='phoneNumber' ref={this.phoneInputRef}/>
									</div>
								</div>
							</div>
							<TextInput errors={errors.email}
									   isRequired={this.isRequired('email')}
									   name="Почта"
									   inputProps={{
										   onChange: this.onChangeInput('email'),
										   value: state.values.email,
										   placeholder: "Введите почту",
										   id: "email",
									   }}
							/>
						</div>
					</div>
				</div>
				<div className="form__footer">
					{
						!!errors && Object.values(errors).map((item) => {
							return (
								<p className="form__error-text">{item}</p>
							);
						})
					}
					<button onClick={this.onSubmitForm} disabled={Object.keys(errors).length} className="button-primary button-primary_pdv_lg form__submit-btn">{this.state.loading ? 'Отправка заявки':'Отправить заявку'}</button>
				</div>
			</form>
		);
	}

	validate = () => {
		let errors = {};
		const self = this;
		if(!this.submitted) return errors;

		const {values} = this.state;

		this.requiredFields.forEach(requiredField => {
			 if(typeof values[requiredField] === "undefined" || values[requiredField] === null ||  values[requiredField].length === 0)
			{
				const fieldName = requiredField in self.fieldsName ? self.fieldsName[requiredField]:'';
				errors[requiredField] = `"${fieldName}" обязательно для заполнения`;
			}
		});

		const pattern = /[^а-яА-ЯёЁ\-\s]+$/g;

		errors = {...errors, ...validateByPattern(values.lastName, pattern, 'lastName', 'Фамилия')};
		errors = {...errors, ...validateByPattern(values.firstName, pattern, 'firstName', 'Имя')};
		errors = {...errors, ...validateByPattern(values.surname, pattern, 'surname', 'Отчество')};

		if(values.email && !validateEmail(values.email))
		{
			errors.email = 'E-mail заполнен неверно';
		}

		return errors;
	};

	isRequired = fieldName => this.requiredFields.indexOf(fieldName) !== -1 ? '* ':'';

	getTimeSlot = (planeDate) => {
		this.setState({timeSlot: []});
		if(this.deliveryZoneId.length === 0 || planeDate.length === 0) return;
		const formData = new FormData;
		formData.append('deliveryZone', this.deliveryZoneId);
		formData.append('datePlan', planeDate);

		sendRequest(this.props.urlGetTimeSlot, {body: formData, type: 'POST', showLoader: true}).then((data) => {
			if(data.status >= 500 || data.status === 0)
			{
				$.disMsg('Произошла неизвестная ошибка во время выполнения запроса.</br> Пожалуйста, обратитесь в техподдержку.', {type: 'false'});
				return;
			}
			if(data.data)
			{
				this.setState({timeSlot: data.data});
			}
		});
	};

	getPlaneDate = () => {
		this.setState({date: [], timeSlot: []});
		if(this.deliveryZoneId.length === 0) return;
		const formData = new FormData;
		formData.append('deliveryZone', this.deliveryZoneId);

		sendRequest(this.props.urlGetPlaneDate, {body: formData, type: 'POST', showLoader: true}).then((data) => {
			if(data.status >= 500 || data.status === 0)
			{
				$.disMsg('Произошла неизвестная ошибка во время выполнения запроса.</br> Пожалуйста, обратитесь в техподдержку.', {type: 'false'});
				return;
			}
			if(data.data)
			{
				this.setState({
					date: data.data.filter(date => {
						if (date.available)
						{
							const newDate = new Date(date.year, date.month - 1, date.day);
							const now = new Date()
							const maxDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 3);

							return newDate >= maxDate;
						}

						return false;
					}),
					timeSlot: [],
				});
			}
		});
	};

	getDeliveryZone = (city, street, house) => {
		if(city.length === 0 || street.length === 0 || house.length === 0) return;
		const formData = new FormData;
		formData.append('city', city);
		formData.append('street', street);
		formData.append('home', house);

		sendRequest(this.props.urlGetDeliveryZone, {body: formData, type: 'POST', showLoader: true}).then((data) => {
			if(data.status >= 500 || data.status === 0)
			{
				$.disMsg('Произошла неизвестная ошибка во время выполнения запроса.</br> Пожалуйста, обратитесь в техподдержку.', {type: 'false'});
				return;
			}
			if(data.data) {
				this.deliveryZoneId = data.data;
				this.getPlaneDate();
			} else {
				this.deliveryZoneId = '';
				this.setState({date: [], timeSlot: []});
			}
		});
	};

	onChangeDatePlane = e => {
		this.setValues({
			planeDate: e.target.value,
			timeSlot: ''
		});
		this.getTimeSlot(e.target.value);
	};

	onChangeAddress = e => {
		const contract = this.props.contracts.find(item => item.contractGlobalId === e.target.value);
		this.setValues({
			contractGlobalId: e.target.value,
			regPointId: contract.meterDevice.length ? contract.meterDevice[0].serialNumber:'',
			city: contract.city,
			street: contract.street,
			house: contract.house,
			flat: contract.flat,
			planeDate: '',
			timeSlot: ''
		});
		this.getDeliveryZone(contract.city, contract.street, contract.house);
	};

	onChangeInput = (field) => e => {
		this.setValues({[field]: e.target.value});
	};

	setValues = (values) => {
		this.removeErrorsApi(values);
		this.setState((state, props) => ({
			values: {
				...state.values,
				...values
			}
		}));
	};

	removeErrorsApi = (fields) => {
		const self = this;
		Object.keys(fields).map(field => {
			if (field in self.errorsApi)
			{
				delete self.errorsApi[field];
			}
		})
	}

	onSubmitForm = (e) => {
		e.preventDefault();
		const self = this;
		this.submitted = true;
		const errors = this.validate();
		if(Object.keys(errors).length)
		{
			this.forceUpdate();
			return;
		}

		this.setState({loading: true});
		const formData = new FormData;
		const {values} = this.state;
		const contract = this.props.contracts.find(item => item.contractGlobalId === values.contractGlobalId);
		let meterDevice = contract.meterDevice.find(item => item.serialNumber === values.regPointId);
		if (!meterDevice) {
			meterDevice = {
				'name': 'Нет данных',
				'regPointId':  values.regPointId
			}
		}

		formData.append('contractGlobalId', values.contractGlobalId);
		formData.append('city', values.city);
		formData.append('street', values.street);
		formData.append('house', values.house);
		formData.append('flat', values.flat);
		formData.append('regPointId', meterDevice.regPointId);
		formData.append('regPointName', meterDevice.name);
		formData.append('lastName', values.lastName);
		formData.append('firstName', values.firstName);
		formData.append('surname', values.surname);
		formData.append('phoneNumber', values.phoneNumber);
		formData.append('email', values.email);
		formData.append('products[]', values.products);
		formData.append('planeDate', values.planeDate);
		formData.append('timeSlot', values.timeSlot);
		formData.append('deliveryZone', this.deliveryZoneId);

		sendRequest(this.props.urlCreate, {body: formData, type: 'POST', headers: {contentType: false, processData: false}, showLoader: true}).then((data) => {
			self.setState({loading: false});
			if(data.status === 200)
			{
				this.clearForm();
				if (typeof this.props.onSubmited === 'function') {
					this.props.onSubmited();
				}
			}
			if(data.status === 422)
			{
				JSON.parse(data.data).map((item) => {
					self.errorsApi[item['field']] = item.message;
				});
			}
			if(data.status >= 500 || data.status === 0)
			{
				$.disMsg('Произошла неизвестная ошибка во время выполнения запроса.</br> Пожалуйста, обратитесь в техподдержку.', {type: 'false'});
				return;
			}
		});
	};
}
